var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{directives:[{name:"web-title",rawName:"v-web-title"}],attrs:{"data-title":"常住人"}}),_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('i-col',{attrs:{"lg":4}},[_c('SideBar',{staticClass:"mobile-no-sidebar"})],1),_c('i-col',{attrs:{"xs":24,"md":24,"lg":12}},[_c('GuestList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }